var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-inline"},[(_vm.nickname)?_c('b-tooltip',{attrs:{"label":_vm.address,"position":"is-right"}},[_vm._v(_vm._s(_vm.nickname))]):_c('span',[_vm._v(_vm._s(_vm.address))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }